export class Observable {
  private value: unknown;
  private valueLog: unknown[] = [];
  private observers: Function[] = [];
  constructor(value: unknown) {
    this.value = value;
    this.valueLog.push(value);
  }
  get() {
    return this.value;
  }
  getLogs() {
    return this.valueLog;
  }
  update(value: unknown) {
    this.value = value;
    this.valueLog.push(value);
    this.observers.forEach((observer) => observer(value));
  }
  subscribe(observer: Function) {
    this.observers.push(observer);
    return observer;
  }
  unsubscribe(observer: Function) {
    this.observers = this.observers.filter((obs) => obs !== observer);
  }
}
